<script lang="ts">
    import './new-button-styles.less';
    import type {ComponentSize, ButtonStyle, ButtonType} from '../types';
    import type {ActionArray} from 'shared/utils/svelte-actions-utils';
    import {tooltip} from 'shared/ui-widgets/tooltip/use.tooltip';
    import {focusOnMount} from 'shared/value-editors/internal/shared/use.focus-on-mount';
    import {exists} from 'shared/utils/custom-utils';
    import {useActions} from 'shared/utils/svelte-actions-utils';

    export let buttonStyle: ButtonStyle = 'default';
    export let buttonSize: ComponentSize = 'md';
    export let buttonType: ButtonType = 'button';
    export let isBlock = false;
    export let isDisabled = false;
    export let additionalClasses = '';
    export let id: string | null = null;
    export let title: string | null = null;
    export let noWrap = false;
    export let focused = false;
    export let rounded = false;
    export let tooltipLabel: string | null = null;
    export let dataQa: string | null = null;
    export let use: ActionArray = [];

    $: buttonClasses = `btn btn-${buttonStyle} btn-${buttonSize} ${isBlock ? 'btn-block' : ''} ${rounded ? 'btn-rounded' : ''}`;
</script>

<button type={buttonType}
        {id}
        {title}
        {...$$restProps}
        class="kp-button {buttonClasses} {additionalClasses}"
        class:no-text-wrap={noWrap}
        disabled={isDisabled}
        data-qa="{dataQa}"
        use:focusOnMount={focused}
        use:useActions={use}
        use:tooltip={{enabled: exists(tooltipLabel), content: tooltipLabel ?? '', role: 'tooltip'}}
        on:click
        on:focus
        on:blur
        on:contextmenu
        on:dblclick
        on:focusin
        on:focusout
        on:keydown
        on:keyup
        on:mouseenter
        on:mouseleave
        on:mousemove
        on:mouseout
        on:mouseover
        on:mouseup
        on:toggle>
    <slot/>
</button>

<style lang="less">
    .kp-button {
        white-space: normal;

        &.no-text-wrap {
            white-space: nowrap;
        }
    }

    .btn-link {
        color: darkblue;
    }
</style>